module.exports = __webpack_public_path__ + "img/Res_Mus_6kl.e1869576.jpg";